import React, { FC, useEffect } from 'react';

import { Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { FormikProps } from 'formik';

import { HelpTypes, searchedAllUsers } from '@pharmaplan/common';
import strings from '../../../localization';
import CustomDropdown from '../../common/CustomDropdown';
import FilterSubmitButtons from '../../common/FilterSubmitButtons';
import genericClasses from '../../../theme/GenericClasses';
import CustomAutocomplete from '../../common/CustomAutocomplete';
import { entitlementStatusDropdown, UserTypesDropdown } from '../../../helpers/Constants';
import { useAppSelector } from '../../../hooks/useAppSelector';
import { toOptions } from '../ExpressBooking/ExpressBooking';

import { styles } from './styles';
import useAutoComplete from '../../../hooks/useAutocomplete';

interface IEntitlementsHeader {
  formik: FormikProps<any>;
  handleReset: () => void;
}

const EntitlementsHeader: FC<IEntitlementsHeader> = ({
  formik,
  handleReset,
}) => {
  const { users: formikUsers } = formik.values;

  const users = useAppSelector(searchedAllUsers);
  const userOptions = toOptions(users);

  const userOption = userOptions;

  const { debouncedInput: userInput } = useAutoComplete({
    userTypes: [HelpTypes.pharmacy, HelpTypes.technicians, HelpTypes.pharmacist],
  });

  useEffect(() => {
    userInput(formikUsers);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formikUsers]);

  return (
    <Box component="form" onSubmit={formik.handleSubmit}>
      <Box sx={styles.titleContainer}>
        <Typography sx={styles.headerFont}>{strings.entitlements}</Typography>
      </Box>
      <Grid
        container
        xs={12}
        alignItems="center"
        wrap="nowrap"
        sx={styles.filterContainer}
      >
        <Grid xs={3} sx={styles.autocomplete}>
          <CustomAutocomplete
            label={strings.user}
            infiniteScroll={!formikUsers}
            idName="personnelId"
            textName="users"
            autoCompleteName="userSelected"
            placeholder={
              strings.formatString(
                strings.selectUser,
                strings.user,
              ) as string
            }
            formik={formik}
            options={userOption}
          />
        </Grid>
        <Grid xs={3} sx={genericClasses.filterMargin}>
          <CustomDropdown
            formik={formik}
            name="status"
            label={strings.status}
            menuItems={entitlementStatusDropdown}
          />
        </Grid>
        <Grid xs={3} sx={genericClasses.filterMargin}>
          <CustomDropdown
            formik={formik}
            name="userType"
            label={strings.userType}
            menuItems={UserTypesDropdown.slice(0, -1)}
          />
        </Grid>
        <FilterSubmitButtons handleReset={handleReset} />
      </Grid>
    </Box>
  );
};
export default EntitlementsHeader;
